<ng-template [ngIf]="isLoadingResults">
  <app-loading></app-loading>
</ng-template>
<div >
  <p-timeline [value]="storico">
     <ng-template pTemplate="marker" let-recordoStorico>
      <span
        class="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1 material-symbols-outlined "
        [ngClass]="stiliService.getStatoPFIcon(recordoStorico.stato.label)"
        [style]="{ 'background-color': stiliService.getStatoPFColor(recordoStorico.stato.label) }">
        {{ stiliService.getStatoPFIcon(recordoStorico.stato.label) }}
      </span>
    </ng-template>
    <ng-template pTemplate="content" let-recordoStorico>
      <div class="flex items-center h-full">
        <span class="font-['Poppins'] mt-1 font-semibold">{{ utilService.formattaDataDaDate(recordoStorico.data) }}</span>
      </div>
    </ng-template>
    <ng-template pTemplate="opposite" let-recordoStorico>
    <!--   <span style="font-weight: bold;" class="mt-2 font-['Poppins']"
        [style]="{ 'color': stiliService.getStatoPFColor(recordoStorico.stato.label) }">
        {{ 
        formattaStorico(recordoStorico)
        }}</span>
        <br> -->
        <p-tag class="mt-3"
            [value]="recordoStorico.stato.label | uppercase"
            [style]="{
              'background-color': stiliService.getStatoPFColor(recordoStorico.stato.label) ,
              'color': '#000000' ,
              'border-radius': '6px',
              'padding': '.25em .5rem',
              'font-weight': '700',
              'font-size': '13px',
              'letter-spacing': '.3px;',
            }"
        ></p-tag>
       
    </ng-template> 
  </p-timeline>
  <div class="pulsanti-container">
    <button pButton pRipple icon="pi pi-cloud-download" (click)="scaricaReportStorico()" label="SCARICA" 
      class="mr-2 p-button-outlined font-['Poppins']" 
      style="color: #2B4162; background-color: #E9F7CA; border-color: #2B4162;">
    </button>
    <button pButton pRipple icon="pi pi-times" (click)="dialogRef.close(true)" label="CHIUDI" 
      class="p-button-outlined font-['Poppins']" 
      style="color: #2B4162; background-color: #C6D8AF; border-color: #2B4162;">
    </button>
  </div>
<div>
